(ns hypnos.dme.tile.patients
  "The patients table."
  (:require [hypnos.dme.subs]
            [hypnos.i18n :refer [tr]]
            [hypnos.time :as t]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Identities

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

#_(defn- therapist
    "Therapist working on the patient consult."
    [patient]
    (str (get-in patient [:patient/last-consult :consult/user :user/first-name])
         " "
         (get-in patient [:patient/last-consult :consult/user :user/last-name])))

(defn- header
  "Patients table header (row)."
  []
  [:tr
   [:th]
   [:th (tr :ui.label/org)]
   ;; [:th (tr :ui.label/therapist)]
   [:th (tr :ui.label/patient-key)]
   [:th (tr :ui.label/last-name)]
   [:th (tr :ui.label/first-name)]
   [:th (tr :ui.label/dob)]
   ;; [:th (tr :ui.label/consult) " " (tr :ui.label/status)]
   ;; [:th (tr :ui.label/modified-on)]
   [:th]
   [:th]])

(defn- row
  "Table row containing the patient/consult details."
  [patient]
  [:tr
   [:td]
   [:td (get-in patient [:patient/organization :organization/key])]
   ;; [:td (therapist patient)]
   [:td (:patient/key patient)]
   [:td (:patient/last-name patient)]
   [:td (:patient/first-name patient)]
   [:td (t/format-date t/MMM-d-YYYY (:patient/dob patient))]
   ;; [:td (tr :ui/consult-status
   ;;          (get-in patient [:patient/last-consult :consult/status]))]
   ;; [:td (t/format-date t/MM-dd-YYYY-HH-MM-SS
   ;;                     (t/to-default-time-zone (get-in patient [:patient/last-consult :consult/recorded-at])))]
   [:td [:div.buttons.is-right.has-addons
         [:a.button.is-small.is-link
          {:href (str "/patient/" (:patient/id patient))}
          [:span.icon [:i.mdi.mdi-eye]]]]]
   [:td]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Table

(defn table
  "The patient table."
  [patients]
  (let [loading? (rf/subscribe [:dme/gql-request-in-progress?])]
    (cond
      @loading?
      [:div.card-content
       [:section.section
        [:div.content.has-text-grey.has-text-centered
         [:p
          [:span.icon.is-large
           [:i.mdi.mdi-loading.mdi-48px.mdi-spin]]]
         [:p (tr :ui.label/loading)]]]]
      (empty? (:patients patients))
      [:div.card-content
       [:section.section
        [:div.content.has-text-grey.has-text-centered
         [:p
          [:span.icon.is-large
           [:i.mdi.mdi-account-outline.mdi-48px]]]
         [:p (tr :ui.label/no-patients)]]]]
      :else
      [:div.table-container
       [:table.table.is-fullwidth.is-striped.is-hoverable.is-sortable.is-fullwidth
        [:thead
         [header]]
        [:tbody
         (for [patient (:patients patients)]
           ^{:key (:patient/id patient)} [row patient])]]])))
